<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/charitable">盛目慈善</router-link>
    </div>
    <div class="banner">
      <img :src="foundation.masterDrawing" alt="">
    </div>
    <div class="content-h" v-html="foundation.briefIntroduction"></div>
    <div class="plate-four">
      <div class="bottom">
        <div class="bottom-left">
          <XSwiper :slideList="(foundation.honorUrl || '').split(',')"></XSwiper>
        </div>
        <div class="bottom-right">
          <div class="item" v-for="(t, i) in incidentAll" :key="i">
            <div class="item-left">
              <p>{{t.incidentTime}}</p>
              <div class="item-spot"></div>
            </div>
            <div class="item-line">
            </div>
            <div class="item-right">
              <p>{{t.incidentExplain}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XSwiper from '@/components/swiper'
import { mapGetters } from 'vuex'
export default {
  components: { XSwiper },
  computed: {
    ...mapGetters(['foundation', 'incidentAll']),
    slideshow() {
      return (this.config.slideshow || '').split(',')
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
$color1: #444;
$color2: #666;
.page {
  width: $page-center;
  margin: auto;
  padding-bottom: 50px;
  color: $color1;
  img {
    max-width: 100%;
  }
  .breadcrumb {
    margin: 50px auto 30px;
  }
  .banner {
    margin-bottom: 50px;
  }
  .content {
    width: 80%;
    margin: auto;
  }
  .plate-four {
    padding: 100px 0 60px;
    &-title {
      width: 205px;
      padding-bottom: 25px;
      margin: 0 auto;
    }
    .top {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      &-left {
        width: 47%;
        padding: 30px 50px;
        text-indent: 2em;
        color: #1c3c8a;
      }
      &-right {
        width: 53%;
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      height: 251px;
      &-left {
        width: 55%;
      }
      &-right {
        width: 43%;
        overflow-y: scroll;
        .item {
          display: flex;
          &-left {
            white-space: nowrap;
            // margin-top: 30px;
            position: relative;
          }
          &-line {
            width: 3px;
            background-color: $color2;
            margin: 0 11px;
            flex-shrink: 0;
          }
          &-spot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: $color2;
            position: absolute;
            top: 10.5px;
            right: -17px;
            transform: translateY(-50%);
          }
          &-right {
            margin-bottom: 30px;
          }
        }
        .item:nth-last-of-type(1) {
          .item-right {
            margin-bottom: 0;
          }
        }
      }
      // &-right::-webkit-scrollbar {
      //   display: none;
      // }
    }
  }
}
</style>
